import { Button, Grid, Tooltip, Typography } from '@mui/material'
import React, { Fragment, useState } from 'react'
import { Loading } from '../../../UI'
import { Modal } from '../../../_EOS/Modal'
import { useModal } from '../../../../hooks/useModal'
import { ModalAsnComment } from './ModalAsnComment'

interface ModalAsnReceivedProps {
  asnId: number
  handleCloseModal: () => void
  handleSubmitAction: (
    asnId: number,
    comment?: string,
    isReserve?: boolean
  ) => void
  isLoading: boolean
}

export const ModalAsnReceived: React.FC<ModalAsnReceivedProps> = ({
  asnId,
  handleSubmitAction,
  isLoading
}) => {
  const commentModalState = useModal<{
    id: number
  }>('')

  const [comment, setComment] = useState<string>('')

  const requestReceivedAsn = () => {
    handleSubmitAction(asnId, comment.trim(), true)
    setComment('')
    commentModalState.closeModal()
  }

  if (isLoading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Typography variant='h6'>{`Seleccione Tipo de Recepción ASN N° ${asnId}`}</Typography>
        </Grid>
        <Grid item xs={6} container justifyContent='center'>
          <Tooltip
            title='ASN se podra recepcionar por posicionamiento habitual'
            placement='top-end'
          >
            <Button
              className='btn-upload'
              color='primary'
              variant='contained'
              component='span'
              onClick={() => handleSubmitAction(asnId)}
            >
              Posicionamiento Habitual
            </Button>
          </Tooltip>
        </Grid>
        <Grid item xs={6} container justifyContent='center'>
          <Tooltip
            title='ASN se podra almacenar temporalmente en Ubicación de Reserva'
            placement='top-end'
          >
            <Button
              className='btn-upload'
              color='primary'
              variant='contained'
              component='span'
              onClick={() => {
                commentModalState.openModal(
                  'sm',
                  { id: asnId },
                  'Recepción a Reserva'
                )
              }}
            >
              Almacenar En Reserva
            </Button>
          </Tooltip>
        </Grid>
      </Grid>

      <Modal
        onClose={commentModalState.closeModal}
        open={commentModalState.isOpen}
        maxWidth={commentModalState.size}
        title={commentModalState.title}
      >
        <ModalAsnComment
          handleCloseModal={commentModalState.closeModal}
          requestCommentAsn={requestReceivedAsn}
          setComment={setComment}
          comment={comment}
        />
      </Modal>
    </Fragment>
  )
}
